import { PageRouteBuilder } from "@common/route/page-route-builder";
import { CopyTeamPageComponent } from "./copy-team-page.component";

export const copyTeamPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-copy-team-page", CopyTeamPageComponent)
    .requiresLogin()
    .atUrl("/tools/copy-team")
    .withTitle("Copy Team")
    .build();
